import React, {Component} from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {startCase} from '../../../shared/utils/lodash-functions';
import {grid} from '../../../shared/utils/grid';
import SmallText from '../../../shared/library/typography/small-text';
import {GUNSMOKE, ASH} from '../../../shared/style/colors';
import {FONT_FAMILY} from '../../../shared/style/typography';
import {PHONE} from '../../style/breakpoints';

const TagsContainer = glamorous.div({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  paddingTop: grid(1),
  [PHONE]: {
    justifyContent: 'center',
    width: '100%'
  }
});

const TagLink = glamorous.a({
  textDecoration: 'none'
});

const Tag = glamorous(SmallText)({
  marginRight: grid(1),
  fontFamily: FONT_FAMILY,
  letterSpacing: 0.5,
  color: GUNSMOKE,
  border: `1px solid ${ASH}`,
  borderRadius: 100,
  padding: '5px 14px',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  lineHeight: '36px'
});

export default class Tags extends Component {
  static propTypes = {
    tags: PropTypes.array,
    onClick: PropTypes.func,
    disableLinks: PropTypes.bool
  };

  static defaultProps = {
    tags: []
  };

  renderTags() {
    const {tags, onClick, disableLinks = false} = this.props;
    return tags.slice(0, 4).map(tag => {
      const {name} = tag;
      return (
        <div key={name}>
          {disableLinks ? (
            <div>
              <Tag>{startCase(name)}</Tag>
            </div>
          ) : (
            <TagLink href={`/stacks/${name}`} onClick={onClick ? () => onClick(name) : null}>
              <Tag>{startCase(name)}</Tag>
            </TagLink>
          )}
        </div>
      );
    });
  }

  render() {
    return <TagsContainer>{this.renderTags()}</TagsContainer>;
  }
}
